export default "__VITE_ASSET__CKP7C_ii__"